import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type FavoriteService from 'frontend/services/favorite';

export interface FavoriteButtonComponentArgs {
  productId: string;
}

export default class FavoriteButtonComponent extends Component<FavoriteButtonComponentArgs> {
  @service declare favorite: FavoriteService;

  get isFavorite() {
    return this.favorite.isFavorite(this.args.productId);
  }

  @action
  async addToFavorites(e: Event): Promise<void> {
    e.preventDefault();
    e.stopImmediatePropagation();

    if (this.isFavorite) {
      await this.favorite.remove(this.args.productId);
    } else {
      await this.favorite.add(this.args.productId);
    }
  }
}
